var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTruck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 12.3333V1.5H0.833008V12.3333H13.333ZM13.333 12.3333H19.1663V8.16667L16.6663 5.66667H13.333V12.3333ZM6.66634 14.4167C6.66634 15.5673 5.7336 16.5 4.58301 16.5C3.43241 16.5 2.49967 15.5673 2.49967 14.4167C2.49967 13.2661 3.43241 12.3333 4.58301 12.3333C5.7336 12.3333 6.66634 13.2661 6.66634 14.4167ZM17.4997 14.4167C17.4997 15.5673 16.5669 16.5 15.4163 16.5C14.2657 16.5 13.333 15.5673 13.333 14.4167C13.333 13.2661 14.2657 12.3333 15.4163 12.3333C16.5669 12.3333 17.4997 13.2661 17.4997 14.4167Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTruck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/truck.351161d3.svg";
export { ForwardRef as ReactComponent };